import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { typography, breakpoints } = useTheme();

  return {
    base: css`
      height: 100%;
      display: grid;
      grid-template-rows: auto auto auto;
      grid-template-columns: 100%;
    `,
    heroWrapper: css`
      position: relative;
      z-index: 1201;
    `,
    hero: css`
      &::before {
        ${breakpoints.m} {
          top: 15vh;
        }

        ${breakpoints.xl} {
          top: 6vh;
        }
      }

      h1 {
        ${typography.headings[4].mobile};
        max-width: 90%;
        font-size: 42px;
        text-transform: capitalize;
        position: relative;
        padding-bottom: 20px;
        text-align: center;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 70px;
          height: 2px;
          background-color: rgb(225, 38, 28);
        }

        ${breakpoints.m} {
          ${typography.headings[3].desktop};
          font-size: 48px;
          max-width: 100%;
          margin: auto;
          position: relative;
          padding-bottom: 20px;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            width: 70px;
            height: 2px;
            background-color: rgb(225, 38, 28);
          }
        }
      }

      grid-template-rows: 82% 18%;

      ${breakpoints.m} {
        text-align: center;
        margin-bottom: 18rem;
        grid-template-rows: 80% 20%;
      }

      ${breakpoints.xl} {
        margin-bottom: 18rem;
        grid-template-rows: 76% 24%;
        h1 {
          max-width: 100%;
          font-size: 48px;
          text-align: center;
        }
      }
      @media screen and (min-width: 1440px) {
        margin-bottom: 17rem;
      }
    `,
    wrapper: css`
      position: relative;
      // padding: 0;

      ${breakpoints.m} {
        grid-template-columns: repeat(2, 1fr);
      }
      ${breakpoints.l} {
        grid-template-columns: repeat(3, 1fr);
      }
    `,
    visibility: length => css`
      visibility: ${length > 0 ? 'visible' : 'hidden'};
    `,
    displayMLData: css`
      display: none;
    `,
    cardContainer: filterShowHide => css`
      display: grid;
      grid-gap: 2.5rem;
      grid-template-columns: repeat(1, 1fr);
      ${breakpoints.m} {
       grid-template-columns: repeat(2, 1fr);
      }
      ${breakpoints.l} {
       grid-template-columns: repeat(3, 1fr);
      }
    `,
    mainContainer: filterShowHide => css`
      padding: 0 1rem;
      flex: 1;
      ${breakpoints.m} {
        padding: 0 3rem;
      }
      @media (max-width: 767px) {
        display: ${filterShowHide ? 'none' : 'block'};
      }
    `,
    noOppOpenFilterDiv: filterShowHide => css`
      display: ${filterShowHide ? 'none' : 'flex'};
      flex-direction: column;
      width: 100%;
      @media (min-width: 767px) {
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    `,
    loadMore: css`
    margin: 2.5rem 0 0 0;
    p{
      color: #e1261c;
    }
    `,
  };
};
